import { useRef } from 'react'
import { useInactiveUpdate } from 'apps/builder/lib/hooks/inputHooks'

export const ModernTextAreaInput = ({
  id,
  placeholder,
  value = '',
  onChange,
  label,
  disabled,
  validation = false,
  autoFocus = false,
  resetScroll = false,
  additionalClasses,
  additionalProps = {},
}) => {
  const textAreaRef = useRef(null)
  const { inputValue, errors, handleChange, handleBlur, handleKeyUp } =
    useInactiveUpdate(value, validation, onChange, { ...additionalProps })

  const resetScrollPosition = () => {
    if (resetScroll) {
      textAreaRef.current.scrollTop = 0
    }
  }
  
  return (
    <div
      className={`foundry--input-fields modern--input
         ${errors ? 'foundry--field-error' : ''} ${
        additionalClasses ? additionalClasses : ''
      }
    `}
    >
      <textarea
        id={id}
        className="input-fields__textarea"
        value={inputValue}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={({ target }) => {
          const { value } = target
          handleChange(value)
        }}
        onKeyUp={handleKeyUp}
        onBlur={() => {
          resetScrollPosition()
          handleBlur()
        }}
        disabled={disabled}
        ref={textAreaRef}
        {...additionalProps}
      />

      {label && (
        <label htmlFor={id} className="input-fields__label">
          {label}
        </label>
      )}
      
      {errors && (
        <div className="field-error--wrap">
          <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
          <span className="field-error--message">{errors}</span>
        </div>
      )}
    </div>
  )
}
